import AOS from "aos"

/**
 * @title Initialise AOS
 * @description Logic for handling the Animate On Scroll library
 */
function initialiseAnimateOnScroll() {
  AOS.init({
    easing: "ease-in-out",
  })

  // Required fix when using the AOS and Swiper libraries together.
  window.addEventListener("scroll", function () {
    AOS.refresh()
  })
}

export default initialiseAnimateOnScroll
